import copyToClipboard from "util/copyToClipboard";
const CopyFieldToClipboard = ({ field }) => copyToClipboard(field);
export default CopyFieldToClipboard;
